const config = {
    baseAppUrl: {
        $default: 'https://localhost:4000',
        staging: 'https://dev-app.spybadao.com',
        production: 'https://app.spybadao.com',
    },
    baseUrl: {
        $default: 'http://localhost:3001',
        staging: 'https://admin-dev-app.spybadao.com',
        production: 'https://admin-app.spybadao.com',
    },
    baseAPI: {
        $default: 'http://localhost:3001',
        staging: 'https://dev-app.spybadao.com',
        production: 'https://app.spybadao.com',
    },
    baseAdminAPI: {
        $default: 'http://localhost:1238',
        staging: 'https://dev-app.spybadao.com/admin',
        production: 'https://app.spybadao.com/admin',
    },
    baseAdminAffiliate: {
        $default: 'https://dev-app.spybadao.com/affiliate',
        staging: 'https://dev-app.spybadao.com/affiliate',
        production: 'https://app.spybadao.com/affiliate'
    },
    basePaymentAPI: {
        $default: 'http://localhost:5242',
        staging: 'https://dev-app.spybadao.com/payment',
        production: 'https://app.spybadao.com/payment'
    },
    baseFbResourceAPI: {
        $default: 'http://localhost:5937',
        staging: 'https://dev-app.spybadao.com/fb-resources',
        production: 'https://app.spybadao.com/fb-resources'
    },

};

const _getEnvironment = () => {
    return process.env.REACT_APP_ENV || 'development';
};

export default (key, defaultValue = null) => {
    if (!config.hasOwnProperty(key)) {
        return defaultValue;
    }

    const env = _getEnvironment();
    const _dataConfig = config[key];

    return _dataConfig[env] ? _dataConfig[env] : _dataConfig['$default'] || defaultValue;
};


// WEBPACK FOOTER //
// ./src/helpers/common/getEnv.js